import { Component, Input, OnInit } from '@angular/core';
import { PendingChanges } from '../shared/pending-changes.class';
import { HandoverService } from 'src/app/services/handover.service';
import { Fracture, GroupFracture } from 'src/app/interfaces/fracture';

@Component({
  selector: 'app-handover-detail-fracture',
  templateUrl: './handover-detail-fracture.component.html',
  styleUrls: ['./handover-detail-fracture.component.scss'],
  standalone: false,
})
export class HandoverDetailFractureComponent
  extends PendingChanges
  implements OnInit
{
  @Input() handoverId: number | undefined;
  @Input() wellId: string | undefined;
  @Input() handoverStatusId: number | undefined;
  @Input() readOnlyContent!: boolean;
  @Input() wellName: string | undefined;

  originalFracture: Fracture = {} as Fracture;
  fractures: GroupFracture[] = [];
  hasIntervalBase = false;
  hasIntervalTop = false;
  hasWellboreId = false;
  isLoadingFractures = false;
  hideFooter = true;
  displayedColumns = [
    'reportDate',
    'reportNo',
    'intervalTop',
    'intervalBase',
    'proppantUsed',
    'proppantInFormation',
    'propConcAverage',
    'injectrateaverage',
    'maxPressure',
    'avgPressure',
    'instantPressure',
  ];

  constructor(public handoverService: HandoverService) {
    super();
  }

  ngOnInit(): void {
    if (this.handoverId && this.wellId) {
      this.isLoadingFractures = true;
      this.handoverService
        .getHandoverFracture(
          this.handoverId,
          this.wellId!,
          this.handoverStatusId!
        )
        .subscribe((f: Fracture) => {
          if (f) {
            this.originalFracture = f;

            if (f.groupValues) {
              this.fractures = f.groupValues as GroupFracture[];
            }

            if (f.intervalBase) {
              this.hasIntervalBase = true;
            }
            if (f.wellboreNo) {
              this.hasWellboreId = true;
            }
            if (f.intervalTop) {
              this.hasIntervalTop = true;
            }
            this.hideFooter = this.fractures!.length > 0;
          }
          this.isLoadingFractures = false;
        });
    }
  }
}
